//  项目名称
export const projectName = ''
//  售后电话
export const afterSalePhone = '189 7920 2829'
//  公司名称
export const companyName = '某某公司'
//  版本
export const versions = 'V6.0.1'
//  密钥
export const secretkey='zl20190305-='



// WEBPACK FOOTER //
// ./src/config.js